<template>
  <el-card
    id="calendarCard"
    shadow="hover"
    :body-style="{padding: '20px 30px 30px'}"
    class="mainCard clear-card"
  >
    <div class="title">
      <div class="left defaultCursor">
        {{ $t('settings.manageCalendars') }}
      </div>
      <div
        class="right"
        :class="['mobile', 'tablet'].includes($mq) ? 'mobileMode' : 'deskMode'"
      >
        <el-button
          type="primary"
          round
          @click="openLink"
        >
          {{ $t('settings.calendarConnections') }}
        </el-button>
      </div>
    </div>

    <div>
      {{ $t('settings.calendarDesc') }}
    </div>
  </el-card>
</template>

<script>
export default {
  name: 'CalendarSettings',

  methods: {
    openLink() {
      window.open(`${process.env.VUE_APP_CAS_CLIENT}/settings/calendars/`, '_blank');
    },
  },
};
</script>

<style lang="scss">
#calendarCard {
  margin-bottom: 20px;

  .title {
    margin-bottom: 20px;
    font-weight: bold;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    cursor: default;

    .left {
      font-size: 16px;
    }

    .right {
      &.mobileMode {
        width: 100%;
        padding: 18px 0 0;

        .el-button {
          width: 100%;
        }
      }
    }
  }

  .el-row:not(:last-child) {
    margin-bottom: 20px;

    &.firstRow {
      margin-bottom: 70px;
    }
  }

  .viewBtnWrap {
    margin: 18px 0 0;

    .viewBtn {
      background: transparent;
      color: white;
    }
  }
}
</style>
